type MediaQueryChangeHandler = (
  event: MediaQueryListEvent | MediaQueryList
) => void;

type LegacyMediaQueryList = MediaQueryList & {
  addListener?: (listener: MediaQueryChangeHandler) => void;
  removeListener?: (listener: MediaQueryChangeHandler) => void;
};

export function subscribeToMediaQuery(
  mediaQuery: MediaQueryList,
  listener: MediaQueryChangeHandler
): () => void {
  if (typeof mediaQuery.addEventListener === "function") {
    const eventListener = listener as EventListener;
    mediaQuery.addEventListener("change", eventListener);
    return () => mediaQuery.removeEventListener("change", eventListener);
  }

  const legacyMediaQuery = mediaQuery as LegacyMediaQueryList;
  if (typeof legacyMediaQuery.addListener === "function") {
    legacyMediaQuery.addListener(listener);
    return () => legacyMediaQuery.removeListener?.(listener);
  }

  return () => {};
}

export function readLocalStorage(key: string): string | null {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function writeLocalStorage(key: string, value: string): boolean {
  if (typeof window === "undefined") {
    return false;
  }

  try {
    window.localStorage.setItem(key, value);
    return true;
  } catch {
    return false;
  }
}
